import React from 'react';
interface DataPlaceholderProps { loading?: boolean; children: React.ReactNode; className?: string; }

const DataPlaceholder: React.FC<DataPlaceholderProps> = ({ loading, children, className }) => {
  return (
    <span style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
      {loading ? (
        <span className={`rect-placeholder ${className || ""}`}></span>
      ) : (
        children
      )}
    </span>
  );
};

export default DataPlaceholder;